import { Link } from "react-router-dom";
import styled from "styled-components";
import { Icon } from "../components/Icon";

const FooterContainer = styled.footer`
	display: flex;
	align-items: center;
	padding: 24px;
`;

const FooterLink = styled(Link)`
	display: inline-flex;
	align-items: center;
	padding: 0;
	border: 0;
	background: transparent;
	color: #8f8f8f;
	font-weight: 500;
	font-size: 12px;
	line-height: 100%;
	letter-spacing: 0;
	vertical-align: middle;
	cursor: pointer;
	gap: 24px;
	text-decoration: none;

	&:hover {
		color: #5f5f5f;
	}

	&:focus-visible {
		outline: 2px solid #8f8f8f;
		outline-offset: 4px;
	}
`;

const FooterLogo = styled(Icon)`
	width: 34px;
	height: 20px;
	filter: grayscale(1);
	flex: 0 0 auto;
`;

export const MainFooter = () => {
	return (
		<FooterContainer>
			<FooterLink to="/terms-of-service">
				<FooterLogo name="logoMini" alt="" aria-hidden="true" preserveOriginalColor />
				<span>Terms of Service</span>
			</FooterLink>
		</FooterContainer>
	);
};
